/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./addWidgetDialog.vue?vue&type=template&id=4176cabf"
import script from "./addWidgetDialog.vue?vue&type=script&lang=js"
export * from "./addWidgetDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports